export default "__VITE_ASSET__9bFSQJOF__"